import React, { useEffect, useRef, useState } from "react";

import { connect } from "react-redux";
import { cloneDeep, includes, isEmpty, map, size } from "lodash";

import Emitter from "../../utils/Emitter";

import { getCountryList, getTradeHScodeSuggetions } from "../../actions/defaultDataAction";

import { default as ReactSelect, components } from "react-select";
import { WithContext as ReactTags } from "react-tag-input";

import DropDown from "../DropDown";
import ButtonAdminpanel from "../ButtonAdminpanel";
import { useAuth } from "../../AuthProvider";
import { showLoading } from "../../actions/loaderAction";
import defaultValues from "../../constant/defaultValues";

const MemberFilter = (props) => {

    const { user } = useAuth();
    const { admin } = defaultValues;

    const filterTypeOptions = [{
        label: 'Product',
        value: 'hs_code'
    }, {
        label: 'Buyer/Suppliers',
        value: 'company'
    }];

    const findByOptions = [{
        label: "Buyer",
        value: "Buyer"
    }, {
        label: "Supplier",
        value: "Supplier"
    }]

    const CustomOption = ({ innerRef, innerProps, isSelected, label }) => (

        <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }} className={isSelected ? "div-item-selected" : "div-item-unselected"} >
            {/* <input type="checkbox" checked={isSelected} readOnly /> */}
            {isSelected && <div className={` item-selected `}><label style={{ marginLeft: '8px' }}>{label}</label></div>}
            {!isSelected && <div className={` item-selected2 `}><label style={{ marginLeft: '8px' }}>{label}</label></div>}

        </div>

    );

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            '&:hover': {
            },
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#4c9bdb', // Background of the selected multi-value items
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#fff', // Color of the text inside the multi-value
            fontSize: "20px"
        }),

        multiValueRemove: (provided) => ({
            ...provided,
            color: '#df0024', // Remove button color
            ':hover': {
                backgroundColor: '#df0024', // Background color on hover for the remove button
            },
        }),
    };

    const [filterTypeOptionVal, setFilterOptionVal] = useState(filterTypeOptions[0]);
    const [findByOptionVal, setFindByOptionVal] = useState(findByOptions[1]);
    const [countryList, setCountryList] = useState([]);
    const [tags, setTags] = useState([]);
    const [suggestions, setSuggetions] = useState([]);

    const [country, setSelectedCountry] = useState([]);
    const [isFilteredData, setFilterData] = useState(false);
    const [searchedTxt, setSearchedTxt] = useState(null);
    const initialFilterRef = useRef(true);
    const initialApplyFilterRef = useRef(false);

    const handleFindByChange = (val) => {
        setFindByOptionVal(val);
    }

    const handleTagChange = (tagVal) => {
        // console.log("handleTagChange ======== ", tagVal);
        if (tagVal.value === undefined) {
            tagVal.label = tagVal.text;
        } else {
            tagVal.label = tagVal.value;
        }

        setTags((prevTags) => {
            return [...prevTags, tagVal]
        });
        setSearchedTxt(null);
    }

    const handleRemoveTag = (e, indx) => {
        // console.log("Index ============= ", indx);
        // setTags(tags.filter((_, i) => i !== indx));
        handleDelete(indx);
    }

    const handleDelete = (indx) => {
        setTags(tags.filter((_, i) => i !== indx));
    }

    const handleRemoveAllTags = () => {
        // console.log("handleRemoveAllTags is called .........");
        setTags([]);
        setSuggetions([]);
    }

    const handleInputChange = async (tag) => {
        // console.log("handleInputChange ======= ", tag);
        setSearchedTxt(tag);
        if (size(tag) > 3) {
            await getSuggetions(tag);
        }
        // setTag(tag);
    }

    const handleCountryChange = (val) => {
        setSelectedCountry(val);
    }

    const filterMembers = () => {
        // on search check any filter available
        // check previous and new state are same 
        // console.log("SearchedTxt", searchedTxt);
        const { admin } = defaultValues;
        let user_id = 0;
        if (user) {
            user_id = user.id;
        }
        const filterObj = {};
        filterObj.filterBy = filterTypeOptionVal.value;
        let filterVal = map(tags, 'id');
        if (!isEmpty(searchedTxt)) {
            filterVal.push(searchedTxt);
        }

        filterObj.filter_val = filterVal;
        filterObj.findWhom = findByOptionVal.value;
        filterObj.selected_country = map(country, 'label');
        filterObj.limit = admin.LIMIT;
        filterObj.offset = admin.OFFSET;
        // console.log("filterMembers is called..", filterObj);
        setFilterData(true);
        Emitter.emit("SET_FILTER_MEMBERS", filterObj);
        // Emitter.emit("FILTER_MEMBERS", filterObj);

        setTimeout(() => {
            Emitter.emit("FILTER_MEMBERS", filterObj);
        }, 1000);

        let filter_preferences = {};
        filter_preferences.user_id = user_id;

        let l_filterObj = cloneDeep(filterObj);
        l_filterObj.txt_search = searchedTxt;
        l_filterObj.filterTags = tags;
        //filter_preferences.bsDemoFilter = l_filterObj;

        let old_filter_preferences = localStorage.getItem("filter_preferences_" + user_id);

        try {
            if (!isEmpty(old_filter_preferences) || old_filter_preferences) {
                let parsed_old_filter_preferences = JSON.parse(old_filter_preferences);
                parsed_old_filter_preferences.bsDemoFilter = l_filterObj;
                filter_preferences = parsed_old_filter_preferences;
                localStorage.setItem("filter_preferences_" + user_id, JSON.stringify(filter_preferences));
            } else {
                filter_preferences.bsDemoFilter = l_filterObj;
                localStorage.setItem("filter_preferences_" + user_id, JSON.stringify(filter_preferences));
            }

        } catch (e) {
            console.log("Exception - ", e);
        }

        localStorage.setItem("filter_preferences_" + user_id, JSON.stringify(filter_preferences));
    }

    const resetFilter = () => {
        // console.log("resetFilter is called..");
        props.showLoading();
        const clearAllButton = document.getElementsByClassName("ReactTags__clearAll");
        if (clearAllButton.length > 0) {
            clearAllButton[0].click();
        } else {
            document.getElementsByClassName("search_input")[0].value = "";
        }


        const filterObj = {};
        filterObj.filterBy = filterTypeOptions[0].value;
        filterObj.findWhom = findByOptions[1].value;
        setFilterOptionVal(filterTypeOptions[0]);
        setFindByOptionVal(findByOptions[1]);

        setSelectedCountry([]);
        setSearchedTxt(null);

        filterObj.filter_val = "";

        filterObj.selected_country = [];
        filterObj.table_search = "";
        filterObj.sortDirection = "DESC";
        filterObj.columnName = "Company Name";
        filterObj.limit = admin.LIMIT;
        filterObj.offset = admin.OFFSET;
        Emitter.emit("SET_FILTER_MEMBERS", filterObj);

        setTimeout(() => {
            Emitter.emit("FILTER_MEMBERS", filterObj);
        }, 1000);
        //need to check if filter is already reset then do not call again.

        // setFilterData(false);
        // if (isFilteredData) {
        //     Emitter.emit("FILTER_MEMBERS", filterObj);
        // } else {
        //     console.log("Reset is getting called again...");
        // }

        let user_id = 0;
        if (user) {
            user_id = user.id;
        }

        let filter_preferences = {};
        filter_preferences.bsDemoFilter = {};

        localStorage.setItem("filter_preferences_" + user_id, JSON.stringify(filter_preferences));

    }

    const fetchFilterSelection = async () => {

        const result = await Promise.allSettled([
            props.getCountryList(),
        ]);

        result.forEach((res, indx) => {
            let dataList = [];
            let data = [];
            if (res.status === 'fulfilled') {
                if (includes([0, 1, 3], indx)) {
                    data = res.value;
                } else if (includes([2], indx)) {
                    data = res.value.data;
                }

                if (indx === 0) {
                    dataList = data.map((v) => {
                        return {
                            label: v.name,
                            value: v.id
                        }
                    });
                    setCountryList(dataList);
                }
            } else {
                console.log("Something Went Wrong while fetching index ", indx, "!! ", res.reason);
            }
        });

    }

    const getSuggetions = async (searchVal) => {
        setSuggetions([]);
        if (filterTypeOptionVal.value === "hs_code") {
            await props.getHScodeSuggetions(0, 20, searchVal).then((data) => {
                let d = data;
                let suggetion_data = map(d, (v) => {
                    return {
                        id: v.hs_code,
                        text: `${v.product_desc} (${v.hs_code})`,
                        // text: v.code,
                        value: v.hs_code
                    };
                });
                setSuggetions(suggetion_data);

            })
        }
    }

    const MoreSelectedBadge = ({ items }) => {
        const style = {
            marginLeft: "auto",
            background: "#d4eefa",
            borderRadius: "4px",
            fontFamily: "Open Sans",
            fontSize: "11px",
            padding: "3px",
            order: 99,
        };

        const title = items.join(", ");
        const length = items.length;
        const label = `+ ${length} item${length !== 1 ? "s" : ""} selected`;

        return (
            <div style={style} title={title}>
                {label}
            </div>
        );
    };

    const MultiValue = ({ index, getValue, ...props }) => {
        const maxToShow = 3;
        const overflow = getValue()
            .slice(maxToShow)
            .map((x) => x.label);

        return index < maxToShow ? (
            <components.MultiValue {...props} />
        ) : index === maxToShow ? (
            <MoreSelectedBadge items={overflow} />
        ) : null;
    };


    useEffect(() => {
        if (initialFilterRef.current === true) {
            fetchFilterSelection();
            initialFilterRef.current = false;
        }

    }, [initialFilterRef]);

    useEffect(() => {
        if (initialApplyFilterRef.current === false) {
            props.showLoading();
            if (size(countryList) > 0) {
                let user_id = 0;
                if (user) {
                    user_id = user.id;
                }
                let old_filter_preferences = localStorage.getItem("filter_preferences_" + user_id);
                try {

                    if (!isEmpty(old_filter_preferences) || old_filter_preferences) {
                        let parsed_old_filter_preferences = JSON.parse(old_filter_preferences);
                        const { bsDemoFilter } = parsed_old_filter_preferences;

                        if (!isEmpty(bsDemoFilter)) {
                            const filterObj = {};
                            filterObj.filterBy = "hs_code";
                            // let filterVal = map(tags, 'id');
                            // if (!isEmpty(searchedTxt)) {
                            //     filterVal.push(searchedTxt);
                            // }

                            filterObj.filter_val = bsDemoFilter.filter_val;
                            filterObj.findWhom = bsDemoFilter.findWhom;
                            filterObj.selected_country = bsDemoFilter.selected_country;

                            let t_countries = [];


                            bsDemoFilter.selected_country.map((val) => {
                                const selected_t_countries = countryList.find(
                                    (option) => option.label == val
                                );
                                t_countries.push(selected_t_countries);
                            });

                            setSelectedCountry(t_countries);

                            const selected_f_type = findByOptions.find(
                                (option) => option.value == bsDemoFilter.findWhom
                            );

                            setFindByOptionVal(selected_f_type);

                            setFilterOptionVal(filterTypeOptions[0]);

                            let selected_tgs = bsDemoFilter.filterTags;

                            /*let searchedTxtObj = {
                                className: "",
                                id: bsFilter.txt_search,
                                label: bsFilter.txt_search,
                                text: bsFilter.txt_search
                            }
        
                            selected_tgs.push(searchedTxtObj); */

                            setTags(selected_tgs);

                            filterObj.limit = admin.LIMIT;
                            filterObj.offset = admin.OFFSET;

                            //setSearchedTxt(bsFilter.txt_search);

                            Emitter.emit("SET_FILTER_MEMBERS", filterObj);
                            // Emitter.emit("FILTER_MEMBERS", filterObj);

                            setTimeout(() => {
                                Emitter.emit("FILTER_MEMBERS", filterObj);
                            }, 1000);
                        } else {
                            resetFilter();
                        }

                    } else {
                        resetFilter();
                    }
                    initialApplyFilterRef.current = true;
                } catch (e) {
                    console.log('Execption ..');
                }
            }
        }
    }, [user, countryList]);

    return (

        <div className="bg-white shadow rounded mb-4">
            <div className="buyer-suplier-search-section member-filter">

                <div className="buyer-suplier-section-child" >
                    <DropDown placeholder="Select.." options={findByOptions} value={findByOptionVal} onChange={handleFindByChange} isDisabled={true} />

                </div>

                <div className="buyer-suplier-section-child">
                    <ReactSelect
                        options={countryList}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{ Option: CustomOption, IndicatorSeparator: () => null, MultiValue }}
                        onChange={handleCountryChange}
                        value={country}
                        // onInputChange={handleHsCodeInputChange}
                        removeSelected={false}
                        // isDisabled={isSuperAdmin ? false : (props.isDisable || props.disableProfile)}
                        styles={customStyles}
                        placeholder="Select country"
                        className="member-filter-container"
                        classNamePrefix="member-filter-select"
                        noOptionsMessage={() => "No Country Found"}
                    // isOptionDisabled={() => hs_code.length >= 3}
                    />
                </div>

                <div className="buyer-suplier-section-child">
                    <ReactTags
                        tags={tags}
                        name="search_txt"
                        inputFieldPosition="top"
                        suggestions={suggestions}
                        placeholder="Search by product name, HS Code, keywords..."
                        handleDelete={handleDelete}
                        handleAddition={handleTagChange}
                        // handleDrag={handleDrag}
                        // handleTagClick={handleTagClick}
                        // onTagUpdate={onTagUpdate}
                        // removeComponent={RemoveComponent}
                        handleInputChange={handleInputChange}
                        editable={false}
                        clearAll
                        onClearAll={handleRemoveAllTags}
                        // maxTags={5}
                        allowAdditionFromPaste
                        classNames={{ tagInputField: "form-control form-size w-100 search_input" }}
                        inputProps={{
                            autoComplete: "off"
                        }}
                    />
                </div>

                <div className="filter-search-btn search-btn">
                    <ButtonAdminpanel type="button" onClick={filterMembers}>  <i className="fa-solid fa-magnifying-glass text-white"></i> Search </ButtonAdminpanel>

                    <button type="button" className=" btn filter-reset-btn mx-2" onClick={resetFilter}>
                        <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g fill="none" fillRule="evenodd" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" transform="matrix(0 1 1 0 2.5 2.5)"> <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"></path> <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"></path> </g> </g></svg>
                        Reset</button>
                    {/* <p className="filter-reset-text" onClick={resetFilter}>
                    <i class="fa-solid fa-filter-circle-xmark mx-1"></i>
                        Reset</p> */}
                </div>

            </div>

            <div className="row">
                {/* <div className="col-md-6 col-xl-2" ></div> */}

                <div className="col-md-12 col-xl-12">
                    <div className="selected-custom-tags">
                        {tags.map((val, indx) => {
                            // console.log("value ======= ", val);
                            return (
                                <div key={`tag_${indx}`} className="selected-custom-tags-child">
                                    <div className="selected-custom-tag-text" data-toggle="tooltip" data-placement="top" title={`${val.text}`}>{val.label} </div>
                                    <div className="selected-custom-tag-button">
                                        <i className="fa-solid fa-x mx-1" key={`remove_${indx}`} onClick={(e) => handleRemoveTag(e, indx)}></i>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div >


    )
}

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {
        getCountryList: () => dispatch(getCountryList()),
        // getHSCodeList: () => dispatch(getHSCodeList()),
        getHScodeSuggetions: (offset, limit, searchTxt) => dispatch(getTradeHScodeSuggetions(offset, limit, searchTxt)),
        showLoading: () => dispatch(showLoading())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(MemberFilter));
